import type { Key } from 'react';

import type { TreeViewInterface } from '@stores/reportingTreeStore/toViewModel';

// TODO поменять типы TreeViewInterface на общие
// Собираем массав dataList из объектов вида { key, title } для всех узлов, для поиска родителя
export const getDataList = (data: TreeViewInterface[]): { key: Key; title: string; parentKey?: Key }[] => {
  const generateList = (
    list: TreeViewInterface[],
    dataList: { key: Key; title: string; parentKey?: Key }[],
    parentKey?: Key,
  ): void => {
    for (let i = 0; i < list.length; i++) {
      const node = list[i];
      const { key, title } = node;
      dataList.push({ key, title, parentKey });
      if (node.children) {
        generateList(node.children, dataList, node.key);
      }
    }
  };

  const dataList: { key: Key; title: string; parentKey?: Key }[] = [];
  generateList(data, dataList);
  return dataList;
};

// Находит ключ родителя узла
export const getParentKey = (key: Key, tree: TreeViewInterface[]): Key | undefined => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }

  return parentKey;
};

// Обновляем дерево после загрузки данных узла
export const updateTreeData = (
  list: TreeViewInterface[],
  key: Key,
  children: TreeViewInterface[],
): TreeViewInterface[] =>
  list.map((node) => {
    if (node.key === key) {
      return {
        ...node,
        children,
      };
    }
    if (node.children) {
      return {
        ...node,
        children: updateTreeData(node.children, key, children),
      };
    }
    return node;
  });

export const recursiveFindByCode = <T extends { children?: T[]; key: Key }>(key: Key, data: T[]): T[] | null => {
  for (const obj of data) {
    if (obj.key === key) {
      return [obj];
    }
    if (obj.children && obj.children.length > 0) {
      const result = recursiveFindByCode(key, obj.children);
      if (result) {
        return [{ ...obj }, ...result];
      }
    }
  }
  return null;
};

export const getAllKeyInTree = <T extends { children?: T[]; key: Key }>(tree: T[]): Key[] => {
  const output: Key[] = [];

  const getKey = (data: T[]) => {
    data.forEach((item) => {
      output.push(item.key);

      if (item.children?.length) {
        return getKey(item.children);
      }
    });
  };

  getKey(tree);

  return output;
};

export const findNodeByValueField = (
  value: string | number,
  items: TreeViewInterface[],
  field: string,
): TreeViewInterface | undefined => {
  let i = 0,
    found: TreeViewInterface | undefined;

  for (0; i < items.length; i++) {
    if (items[i][field] === value) {
      return items[i];
    } else if (Array.isArray(items[i].children)) {
      found = findNodeByValueField(value, items[i].children ?? [], field);
      if (found) {
        return found;
      }
    }
  }
};
